module.exports = __webpack_public_path__ + "static/media/NSR - Profile Pic 2025 - White Background.40bbc0e8.png";